import { SettingsTranslationType } from "../../features/settings.types";

export const settings: SettingsTranslationType = {
  settings: {
    title: "الإعدادات",
    aiProvider: {
      label: "مزود الذكاء الاصطناعي",
      select: "اختر مزود",
      description: "اختر مزود الذكاء الاصطناعي لاستخدامه في إنشاء القصص",
      updateSuccess: "تم تحديث مزود الذكاء الاصطناعي",
      updateSuccessDesc: "تم حفظ تفضيلات مزود الذكاء الاصطناعي الخاص بك",
      updateError: "فشل التحديث",
      updateErrorDesc: "فشل تحديث مزود الذكاء الاصطناعي. يرجى المحاولة مرة أخرى."
    },
    language: {
      label: "اللغة",
      description: "اختر لغة الواجهة المفضلة لديك"
    },
    subscription: {
      title: "الاشتراك",
      currentPlan: "الخطة الحالية",
      freeTier: "مجاني",
      basicTier: "أساسي",
      premiumTier: "متميز",
      status: "الحالة",
      renewalDate: "تاريخ التجديد",
      upgradePlan: "ترقية الخطة",
      managePlan: "إدارة الخطة",
      cancelPlan: "إلغاء الخطة",
      features: "الميزات",
      billingCycle: "دورة الفوترة",
      monthlyLabel: "شهري",
      yearlyLabel: "سنوي",
      priceUnits: {
        month: "شهر",
        year: "سنة"
      },
      tiers: {
        free: {
          name: "مجاني",
          description: "ميزات أساسية للبدء",
          price: "مجاني"
        },
        basic: {
          name: "أساسي",
          description: "ميزات متقدمة لكتاب الهواة",
          price: {
            monthly: "$9.99/شهر",
            yearly: "$99/سنة"
          }
        },
        premium: {
          name: "متميز",
          description: "وصول كامل للكتاب المحترفين",
          price: {
            monthly: "$19.99/شهر",
            yearly: "$199/سنة"
          }
        }
      },
      browseCharacters: "تصفح الشخصيات",
      upgradeToBrowse: "قم بالترقية لتصفح مجموعة الشخصيات الخاصة بك",
      upgradeToMakePublic: "قم بالترقية لجعل الشخصيات عامة",
      upgradeRequired: "الترقية مطلوبة",
      upgradeToBrowseDescription: "قم بترقية حسابك لتصفح وإعادة استخدام مجموعة الشخصيات الخاصة بك.",
      upgradeToMakePublicDescription: "قم بترقية حسابك لمشاركة الشخصيات علنًا مع مستخدمين آخرين.",
      unlockFeatures: "فتح الميزات المتميزة مع اشتراك",
      upgradeNow: "الترقية الآن",
      unlockAiTitleGeneration: "فتح توليد العناوين بالذكاء الاصطناعي",
      upgradeForCharaterAccess: "الترقية للوصول إلى إدارة الشخصيات",
      upgradeForStatsAccess: "الترقية للوصول إلى الإحصائيات والشارات",
      upgradeForAccess: "الترقية للوصول إلى هذه الميزة",
      upgradeForAiTitleDescription: "قم بالترقية إلى الخطة الأساسية للوصول إلى توليد العناوين بالذكاء الاصطناعي والحصول على اقتراحات إبداعية بناءً على موضوعات قصتك وشخصياتها وإعداداتها.",
      generateTitlesFeature: "توليد عناوين فريدة على الفور",
      aiTitleGenerationPremium: "توليد العناوين بالذكاء الاصطناعي متاح في الخطة الأساسية",
      unlockGenre: "قم بالترقية لفتح هذا النوع الأدبي",
      unlockCustomGenres: "فتح الأنواع الأدبية المخصصة",
      upgradeForCustomGenresDescription: "قم بالترقية إلى الخطة الأساسية لإنشاء أنواع أدبية مخصصة وجعل قصصك أكثر تميزًا.",
      addCustomGenresFeature: "أضف أنواعًا أدبية مخصصة غير محدودة",
      unlockEnvironment: "قم بالترقية لفتح هذه البيئة",
      upgradeForCustomEnvironments: "قم بالترقية إلى TaleCraft الأساسي لإضافة بيئات مخصصة",
      unlockCustomEnvironments: "فتح البيئات المخصصة",
      upgradeForCustomEnvironmentsDescription: "قم بالترقية إلى الخطة الأساسية لإنشاء بيئات مخصصة وجعل قصصك أكثر تميزًا.",
      addCustomEnvironmentsFeature: "أضف بيئات مخصصة غير محدودة",
      unlockTheme: "قم بالترقية لفتح هذا الموضوع",
      upgradeForCustomThemes: "قم بالترقية إلى TaleCraft الأساسي لإضافة موضوعات مخصصة",
      unlockCustomThemes: "فتح الموضوعات المخصصة",
      upgradeForCustomThemesDescription: "قم بالترقية إلى الخطة الأساسية لإنشاء موضوعات مخصصة وجعل قصصك أكثر تميزًا.",
      addCustomThemesFeature: "أضف موضوعات مخصصة غير محدودة",
      unlockStoryLength: "قم بالترقية لفتح طول القصة هذا",
      upgradeForPremiumLengths: "قم بالترقية إلى TaleCraft الأساسي للوصول إلى قصص أطول",
      unlockPremiumLengths: "فتح أطوال القصص المتميزة",
      upgradeForPremiumLengthsDescription: "قم بالترقية إلى خطة Premium لإنشاء قصص أطول وتطوير سردك بتفاصيل أكثر.",
      longStoriesFeature: "إنشاء قصص بدون قيود طول",
      avatarGenerator: {
        upgradeRequired: "الترقية مطلوبة",
        upgradeDescription: "قم بالترقية لتوليد صور رمزية للشخصيات.",
        premiumFeature: "توليد صور رمزية مخصصة للشخصيات مع اشتراك مميز",
        upgradeNow: "الترقية الآن",
        upgradeTooltip: "قم بالترقية لتوليد صور رمزية للشخصيات"
      },
      planComparison: {
        chooseYourPlan: "اختر الخطة التي تناسب احتياجاتك",
        price: "السعر",
        features: "الميزات",
        talecraftBasic: "تيلكرافت الأساسية",
        talecraftPremium: "تيلكرافت المميزة",
        savePercentage: "وفر 17%",
        currentPlanLabel: "الخطة الحالية:",
        processing: "جاري المعالجة...",
        downgradeToBasic: "التخفيض إلى تيلكرافت الأساسية",
        downgradeToFree: "التخفيض إلى الخطة المجانية",
        upgradeToBasic: "الترقية إلى تيلكرافت الأساسية",
        upgradeToPremium: "الترقية إلى تيلكرافت المميزة",
        downgradingTo: "التخفيض إلى",
        effectiveOn: "سيدخل حيز التنفيذ في",
        nextBillingDate: "تاريخ الفوترة التالي",
        featureItems: {
          dailyStoryLimit: "حد القصص اليومي",
          aiStoryGeneration: "إنشاء القصص بالذكاء الاصطناعي",
          customResponses: "ردود مخصصة",
          aiTitleSuggestion: "اقتراح عناوين بالذكاء الاصطناعي",
          customStorySelection: "اختيار قصص مخصص",
          publicSharing: "المشاركة العامة",
          characterManagement: "إدارة الشخصيات",
          aiProviderSelection: "اختيار مزود الذكاء الاصطناعي",
          statsAndBadges: "الإحصائيات والشارات/الترتيب",
          badgeRewards: "مكافآت الشارات",
          naturalStoryLength: "طول قصة طبيعي",
          sequelsAndExtract: "تتمات واستخراج الشخصيات",
          characterAvatar: "صورة رمزية للشخصية",
          earlyAccessFeatures: "ميزات الوصول المبكر"
        },
        limits: {
          perDay: "/يوم",
          unlimited: "غير محدود"
        }
      }
    },
    profile: {
      displayName: {
        label: "اسم العرض",
        placeholder: "أدخل اسم العرض الخاص بك",
        updateButton: "تحديث الاسم",
        helpText: "اختر اسم عرض فريد لملفك الشخصي"
      },
      inviteFriends: {
        label: "دعوة الأصدقاء",
        button: "دعوة الأصدقاء",
        dialogTitle: "مشاركة الدعوة",
        dialogDescription: "ادعُ أصدقاءك للانضمام إليك في رحلة سرد القصص. شارك رابط الدعوة الفريد الخاص بك أو استخدم وسائل التواصل الاجتماعي.",
        copySuccess: {
          title: "تم نسخ الرابط!",
          description: "تم نسخ رابط الإحالة إلى الحافظة الخاصة بك."
        },
        copyFailure: {
          title: "فشل النسخ",
          description: "يرجى محاولة نسخ الرابط يدويًا."
        },
        shareMessage: "انضم إلي في مغامرة سرد القصص! أنشئ وشارك قصصًا مذهلة معًا.",
        socialPlatforms: {
          facebook: "فيسبوك",
          X: "تويتر",
          linkedin: "لينكد إن",
        }
      },
      upgradeDialog: {
        title: "الترقية مطلوبة",
        aiProviderDescription: "قم بالترقية لتحديد مزود الذكاء الاصطناعي.",
        unlockProviderSelection: "فتح اختيار مزود الذكاء الاصطناعي مع اشتراك"
      }
    },
    issues: {
      title: "الإبلاغ عن مشكلة",
      description: "هل وجدت خطأً أو لديك اقتراح؟ أخبرنا!",
      submitSuccess: "تم الإبلاغ عن المشكلة",
      submitSuccessDesc: "شكراً لملاحظاتك. سنقوم بالتحقيق في المشكلة.",
      submitError: "فشل الإرسال",
      submitErrorDesc: "حدثت مشكلة أثناء الإبلاغ عن المشكلة. يرجى المحاولة مرة أخرى لاحقاً.",
      form: {
        titleLabel: "العنوان",
        titlePlaceholder: "وصف موجز للمشكلة",
        descriptionLabel: "الوصف",
        descriptionPlaceholder: "يرجى تقديم تفاصيل حول المشكلة...",
        priorityLabel: "الأولوية",
        priorityPlaceholder: "اختر الأولوية",
        priorityLow: "منخفضة",
        priorityMedium: "متوسطة",
        priorityHigh: "عالية",
        priorityDescription: "حدد مدى إلحاح هذه المشكلة لمساعدتنا في تحديد أولويتها بشكل صحيح.",
        submit: "إرسال التقرير",
        submitting: "جاري الإرسال...",
        imagesLabel: "إرفاق صور",
        typeLabel: "نوع المشكلة",
        typePlaceholder: "اختر نوع المشكلة",
        typeBug: "خطأ",
        typeRequest: "طلب",
        typeDescription: "حدد نوع المشكلة التي تقدمها",
      },
      imageUpload: {
        dragDrop: "اسحب وأفلت الصور هنا",
        dropHere: "أفلت الصور هنا...",
        clickToSelect: "أو انقر لاختيار الملفات",
        maxSize: "الحد الأقصى 5 ميغابايت",
        maxNumber: "الحد الأقصى 5 صور",
        attachedImages: "الصور المرفقة",
        invalidFiles: "بعض الملفات غير مقبولة",
        sizeTypeLimit: "يجب أن تكون الملفات صورًا بحجم أقل من 5 ميغابايت",
        tooManyImages: "عدد الصور المرفقة كثير جدًا",
        limitReached: "يمكنك إرفاق ما يصل إلى 5 صور فقط",
        pasteSupported: "دعم لصق الصور",
        pasteSuccess: "تم لصق الصورة",
        pasteSuccessDesc: "تم إرفاق الصورة من الحافظة",
        pasteFailed: "فشل لصق الصورة",
        pasteFailedDesc: "تعذر معالجة محتوى الحافظة",
        processing: "جاري معالجة الصورة...",
      },
    }
  }
};
